export default __webpack_public_path__ + "static/media/email.69e0591d.svg";